import { render, staticRenderFns } from "./Texure_master.vue?vue&type=template&id=68a720be&"
import script from "./Texure_master.vue?vue&type=script&lang=js&"
export * from "./Texure_master.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports